import { createReducer, on } from '@ngrx/store';
import * as HelpActions from './help.actions';

export const featureKey = 'help';

export interface HubHelpState {
  helpVisible: boolean
  onBoardingEnabled: boolean
  /**
   * Number of help slideovers rendered by the current page that actually carry
   * page specific content. Kept as a count rather than a flag so overlapping
   * register/unregister calls during a route change cannot lose track.
   */
  pageGuideCount: number
}

export const initialState: HubHelpState = {
  helpVisible: false,
  onBoardingEnabled: false,
  pageGuideCount: 0
};

export const reducer = createReducer(
  initialState,

  on(HelpActions.setHelpVisible, (state, action) => ({
    ...state,
    helpVisible: action.helpVisible
  })),

  on(HelpActions.registerPageGuide, (state) => ({
    ...state,
    pageGuideCount: state.pageGuideCount + 1
  })),

  on(HelpActions.unregisterPageGuide, (state) => ({
    ...state,
    pageGuideCount: Math.max(0, state.pageGuideCount - 1)
  })),

  on(HelpActions.setOnBoardingEnabled, (state, action) => ({
    ...state,
    onBoardingEnabled: action.onBoardingEnabled
  })),

);
